import { render } from "./App.vue?vue&type=template&id=845c46c0&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=845c46c0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-845c46c0"

export default script